import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }

import { useStore } from '../stores/main';

import AppMenu from './AppMenu.vue';
import AppHeader from './AppHeader.vue';
import AppFooter from './AppFooter.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

store.getGroups();

function closeMenu() {
  store.menuOpen = false;
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader),
    _createVNode(AppMenu),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "flex flex-col grow px-4 pt-16 pb-4 lg:pt-32 lg:pr-8 lg:pb-8 lg:pl-28",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (closeMenu()))
      }, [
        _createVNode(_component_router_view)
      ]),
      _createVNode(AppFooter)
    ])
  ], 64))
}
}

})